'use strict';
angular
    .module('editingCenterAppFocusModule', ['editingCenterAppFocusRouterModule'])
    .controller('editCenterAppFocusCtroller', [
        '$stateParams',
        '$q',
        '$filter',
        'trsHttpService',
        '$scope',
        '$modal',
        '$window',
        '$state',
        'modalDialog',
        'trsspliceString',
        '$timeout',
        'initSingleSelecet',
        'editingCenterService',
        'storageListenerService',
        'trsPrintService',
        'globleParamsSet',
        'editingCenterAppService',
        'editcenterRightsService',
        'editIsLock',
        'localStorageService',
        'appFocusApiService',
        'appFocusService',
        function(
            $stateParams,
            $q,
            $filter,
            trsHttpService,
            $scope,
            $modal,
            $window,
            $state,
            modalDialog,
            trsspliceString,
            $timeout,
            initSingleSelecet,
            editingCenterService,
            storageListenerService,
            trsPrintService,
            globleParamsSet,
            editingCenterAppService,
            editcenterRightsService,
            editIsLock,
            localStorageService,
            appFocusApiService,
            appFocusService
        ) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: globleParamsSet.getPageSize(),
                    // PAGESIZE: 3,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 1,
                };
                $scope.data = {
                    items: [],
                    selectedArray: [],
                    copyCurrPage: 1,
                };
                $scope.status = {
                    batchOperateBtn: {
                        hoverStatus: '',
                        clickStatus: '',
                    },
                    channelId: $stateParams.channelid,
                    siteId: $stateParams.siteid,
                    isFocusQueue: true, // 是否出于焦点图队列列表
                    hasChildren: $stateParams.hasChildren,
                };
                $scope.listParams = {
                    PageSize: $scope.page.PAGESIZE,
                    PageIndex: $scope.page.CURRPAGE,
                    ChannelId: $stateParams.channelid,
                    SearchContent: '',
                };
                $scope.sortParams = {
                    ChannelId: $stateParams.channelid,
                    position: 0,
                    FromChnlDocId: '',
                    ToChnlDocId: '',
                };
                $scope.cancelTimingParams = {
                    ChannelId: $stateParams.channelid,
                    ChnlDocIds: '',
                };
                // 监听未保存的专题分组，并删除
                $window.addEventListener('storage', function(e) {
                    var draftInfo = localStorageService.get('unsavedGroup');
                    if (draftInfo && draftInfo.specialGroupIds) {
                        localStorageService.remove('unsavedGroup');
                        deleteUnsavedGroup(draftInfo).then(function(data) {
                            // console.log('删除分组成功！');
                        });
                    }
                });
                $scope.focusQueueLength = 0;
                $scope.allowUptotal = 10;
                $scope.keywords = '';
            }

            $scope.getScheduleTip = function(item) {
                return '时间提示';
            };

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                if (!$stateParams.channelid) {
                    $scope.status.hidePage = true; // 如果栏目参数不足，隐藏该页面
                    return;
                }
                requestData();
                listenStorage();
                editcenterRightsService.initAppListBtn('app.focuspic', $stateParams.channelid).then(function(rights) {
                    $scope.status.btnRights = rights;
                    getObjLength($scope.status.btnRights);
                });
            }

            $scope.switchList = function(bool) {
                if (bool) {
                    $scope.status.isFocusQueue = true;
                    getFocusQueue();
                } else {
                    $scope.status.isFocusQueue = false;
                    getFocusDocs();
                }
            };

            /**
             * [getFocusDocs 获取焦点图库]
             *
             * @return  {[type]}  [return description]
             */
            function getFocusDocs() {
                var deferred = $q.defer();
                appFocusApiService.getFocusList($scope.listParams).then(
                    function(data) {
                        if (data.DATA.length) {
                            $scope.data.selectedArray = [];
                            $scope.data.items = data.DATA;
                            $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                        } else {
                            $scope.data.items = [];
                        }
                        deferred.resolve();
                    },
                    function(data) {
                        deferred.reject(data);
                    }
                );
                return deferred.promise;
            }

            /**
             * [getFocusQueue 获取焦点图队列]
             *
             * @return  {[type]}  [return description]
             */
            function getFocusQueue() {
                var deferred = $q.defer();
                appFocusApiService.getFocusQueue($scope.listParams).then(
                    function(data) {
                        if (data.length) {
                            $scope.data.selectedArray = [];
                            $scope.data.items = data;
                            $scope.focusQueueLength = data.length;
                        } else {
                            $scope.data.items = [];
                            $scope.focusQueueLength = 0;
                        }
                        deferred.resolve();
                    },
                    function(data) {
                        deferred.reject(data);
                    }
                );
                return deferred.promise;
            }

            $scope.isFocusSchedule = function(item) {
                if (item.SCHEDULEDDOWNTIME !== '' || item.SCHEDULEDUPTIME !== '') {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.upSelect = function() {
                var isFocus = false;
                $scope.data.selectedArray.forEach((item) => {
                    if (item.GDORDER > 0 || item.DOCORDERPRI != '0') {
                        isFocus = true;
                    }   
                });
                if (isFocus) {
                    modalDialog.confirmModal('', '上架焦点图会取消该稿件在列表中的置顶（固定位置），是否确定上架', function() {                    
                        if (checkSelect('up')) {
                            $scope.focusUp($scope.data.selectedArray);
                        }
                    });
                }
                if (!isFocus) {
                    if (checkSelect('up')) {
                        $scope.focusUp($scope.data.selectedArray);
                    }
                }     
            };

            $scope.downSelect = function() {
                if (checkSelect('down')) {
                    $scope.focusDown($scope.data.selectedArray);
                }
            };

            $scope.cancelScheduleSelect = function() {
                if (checkSelect('cancel')) {
                    $scope.focusCancelTiming($scope.data.selectedArray);
                }
            };

            /**
             * [checkSelect 检查数据操作合法性]
             *
             * @param   {[type]}  operType  [operType description]
             *
             * @return  {[type]}            [return description]
             */
            function checkSelect(operType) {
                if (operType === 'up') {
                    if (!$scope.status.isFocusQueue) {
                        let total = $scope.data.selectedArray.length + $scope.focusQueueLength;
                        if (total > $scope.allowUptotal) {
                            modalDialog.alertType('上架数量超过了限制', '', 'warning', '');
                            return false;
                        }
                    }
                }
                let canOper = true;
                $scope.data.selectedArray.forEach(function(item) {
                    if (operType === 'up' && $scope.getFocusStatus(item) === '已上架') {
                        modalDialog.alertType('您选择的项目中包含已上架的内容，无法重复上架', '', 'warning', '');
                        canOper = false;
                    }
                    if (operType === 'cancel' && !$scope.isFocusSchedule(item)) {
                        modalDialog.alertType('您所选的项目中未包含定时上下架的项目，无法取消定时', '', 'warning', '');
                        canOper = false;
                    }
                });
                return canOper;
            }

            /**
             * [getObjLength description]计算对象长度
             *
             * @param   {[type]}  obj  [obj description]
             *
             * @return  {[type]}       [return description]
             */
            function getObjLength(obj) {
                var size = 0,
                    key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        size++;
                    }
                }
                $scope.status.btnLength = size;
            }

            /**
             * [requestData 请求数据]
             *
             * @param   {[type]}  type  [type description]
             *
             * @return  {[type]}        [return description]
             */
            function requestData(type) {
                if ($scope.status.isFocusQueue) {
                    getFocusQueue();
                } else {
                    getFocusDocs();
                }
            }

            $scope.getFocusStatus = function(item) {
                let focusStatusMap = {
                    '-1': '已下架',
                    '1': '待上架',
                    '2': '已上架',
                };

                return focusStatusMap[item.FOCUSSHELVESSTATUS];
            };

            /**
             * [description] 监听勾选的数据
             * @param  {[type]} newValue) {                       var hasFixed [description]
             * @return {[type]}           [description]
             */
            $scope.$watch('data.selectedArray.length', function(newValue) {
                var hasFixed = false;
                var hasNoFixed = false;
                var hasHide = false;
                var hasNoHide = false;
                angular.forEach($scope.data.selectedArray, function(item) {
                    angular.isDefined(item.GDORDER) ? (hasFixed = true) : (hasNoFixed = true);
                    item.HIDDEN == '1' ? (hasHide = true) : (hasNoHide = true);
                    $scope.status.hasFixed = hasFixed;
                    $scope.status.hasNoFixed = hasNoFixed;
                    $scope.status.hasHide = hasHide;
                    $scope.status.hasNoHide = hasNoHide;
                });
            });

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenApp(function() {
                    requestData();
                    storageListenerService.removeListener('app');
                }, $scope);
            }

            /**
             * [selectAll description] 全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            };

            /**
             * [selectDoc description] 单选
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
            };

            // h5拖拽开始
            // $scope.dragoverCallback = function(event, index, external, type) {
            //     return index < 10;
            // };
            $scope.dropCallback = function(event, index, item, external, type, allowedType) {
                if (!$scope.status.btnRights['app.focuspic.sort']) {
                    modalDialog.alertType('登录用户没有权限对稿件进行排序', '', 'warning', '');
                    return;
                }
                var trueIndex;
                $scope.sortParams.FromChnlDocId = item.RECID;
                if ($scope.moveIndex < index) {
                    trueIndex = index - 1;
                    $scope.sortParams.position = 1;
                } else {
                    trueIndex = index;
                    $scope.sortParams.position = 0;
                }
                $scope.sortParams.ToChnlDocId = $scope.data.items[trueIndex].RECID;
                modalDialog.alertType(
                    '位置调整',
                    '确定调整位置么？',
                    'info',
                    true,
                    function() {
                        $scope.loadingPromise = appFocusApiService.FocusSort($scope.sortParams).then(function(data) {
                            if (data.ISSUCCESS === 'true') {
                                modalDialog.alertType('排序成功', data.DETAIL, 'success', false);
                                requestData();
                            }
                        });
                    },
                    function() {
                        requestData();
                    }
                );
                return item;
            };
            // h5拖拽结束
            $scope.getIndex = function(index) {
                $scope.moveIndex = index;
            };

            /**
             * [showVersionTime description]展示流程版本与操作日志
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.showVersionTime = function(item) {
                editingCenterService.getVersionTime(item, false);
            };

            /**
             * [selectPageNum description]每页显示的数据数量
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectPageNum = function() {
                $scope.data.copyCurrPage = 1;
                $scope.params.PageSize = $scope.page.PAGESIZE;
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [pageChanged description] 分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.data.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [jumpToPage description] 跳转到指定页面
             * @return {[type]} [description]
             */
            $scope.jumpToPage = function() {
                if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.CurrPage = $scope.data.copyCurrPage;
                $scope.page.CURRPAGE = $scope.data.copyCurrPage;
                requestData();
            };

            /**
             * [fullTextSearch description]全文检索
             *
             * @param   {[type]}  ev  [ev description]按下回车也能提交
             *
             * @return  {[type]}      [return description]
             */
            $scope.fullTextSearch = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.page.CURRPAGE = 1;
                    getFocusDocs();
                }
            };

            /**
             * [appPreview description] app稿件预览
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.appPreview = function(item) {
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID,CHNLDOCID', 'appPreview');
            };

            /**
             * [appMobilePreview description]客户端手机端模板预览
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.appMobilePreview = function(item) {
                editingCenterAppService.appPrevewPublish(item.CHNLDOCID).then(
                    function() {},
                    function() {
                        editIsLock.lockDraft(item.CHNLDOCID);
                    }
                );
            };

            $scope.singleOper = function(item, operType) {
                if (operType === 'up') {
                    if (item.GDORDER > 0 || item.DOCORDERPRI != '0') {
                        modalDialog.confirmModal('', '上架焦点图会取消该稿件在列表中的置顶（固定位置），是否确定上架', function() {
                            $scope.data.selectedArray = [];
                            $scope.data.selectedArray.push(item);
                            if (checkSelect(operType)) {
                                if (operType === 'up') {
                                    $scope.focusUp(item);
                                } else if (operType === 'down') {
                                    $scope.focusDown(item);
                                } else if (operType === 'cancel') {
                                    $scope.focusCancelTiming(item);
                                }
                            }
                        });
                    } else {
                        $scope.data.selectedArray = [];
                        $scope.data.selectedArray.push(item);
                        if (checkSelect(operType)) {
                            if (operType === 'up') {
                                $scope.focusUp(item);
                            } else if (operType === 'down') {
                                $scope.focusDown(item);
                            } else if (operType === 'cancel') {
                                $scope.focusCancelTiming(item);
                            }
                        }
                    }
                } else {
                    $scope.data.selectedArray = [];
                    $scope.data.selectedArray.push(item);
                    if (checkSelect(operType)) {
                        if (operType === 'up') {
                            $scope.focusUp(item);
                        } else if (operType === 'down') {
                            $scope.focusDown(item);
                        } else if (operType === 'cancel') {
                            $scope.focusCancelTiming(item);
                        }
                    }
                }
               
            };

            $scope.focusUp = function(item) {
                let arr = [];
                if (angular.isArray(item)) {
                    arr = item;
                } else {
                    arr.push(item);
                }
                appFocusService.appFocusTiming(arr, 1, function(result) {
                    if (result.ISSUCCESS === 'true') {
                        modalDialog.alertType('上架成功', result.REPORTS.DETAIL, 'success', false);
                        requestData();
                    } else {
                        modalDialog.alertType('上架失败！', result.REPORTS.DETAIL, 'error');
                    }
                });
            };

            $scope.focusDown = function(item) {
                let arr = [];
                if (angular.isArray(item)) {
                    arr = item;
                } else {
                    arr.push(item);
                }
                appFocusService.appFocusTiming(arr, 0, function(result) {
                    if (result.ISSUCCESS === 'true') {
                        modalDialog.alertType('下架成功', result.REPORTS.DETAIL, 'success', false);
                        requestData();
                    } else {
                        modalDialog.alertType('下架失败！', result.REPORTS.DETAIL, 'error');
                    }
                });
            };

            $scope.focusCancelTiming = function(item) {
                let arr = [];
                if (angular.isArray(item)) {
                    arr = item;
                } else {
                    arr.push(item);
                }
                modalDialog.confirmModal('', '确定取消定时任务？', function() {
                    $scope.cancelTimingParams.ChnlDocIds = trsspliceString.spliceString(arr, 'RECID', ',');
                    appFocusApiService.FocusCancelTiming($scope.cancelTimingParams).then(function(data) {
                        if (data.ISSUCCESS) {
                            modalDialog.alertType('取消成功', data.REPORTS.DETAIL, 'success', false);
                            requestData();
                        } else {
                            modalDialog.alertType('取消失败！', data.REPORTS.DETAIL, 'error', 'confirm', function() {});
                        }
                    });
                });
            };
        },
    ])
    .directive('focusBigpic', [
        '$sce',
        '$timeout', 
        '$compile',
        function($sce, $timeout, $compile) {
            return {
                restrict: 'A',
                link: function($scope, $element, $attrs) {
                    let subScope = $scope.$new(true);

                    let showBig = function () {
                        let url = $attrs.src;
                        var hint = $compile('<div class="focus-big-picture"><img src="' + url + '" /></div>')(subScope);
                        $element.after(hint);

                        hint.on('mouseleave', function(event){
                            event.target.remove();
                        });
                    };

                    let hideBig = function () {
                        $element[0].nextElementSibling && $element[0].nextElementSibling.remove();
                    };
                    
                    $element.on('mouseenter', function(){
                        showBig();
                    });

                    $element.parent().on('mouseleave', function(){
                        hideBig();
                    });
                },
            };
        },
    ]);
